// @TODO: move it to the store later
import { UserModelType } from 'entities/Profile.entity'

export function isProfileACreator(user?: UserModelType | null): boolean {
    if (user) return user.role?.type === 'creator'
    else return false
}